export async function encryptTextWithPassword (password, text) {
  const key = await deriveKey(password)
  return encrypt(key, text)
}

export async function decryptTextWithPassword (password, encryptedObj) {
  const key = await deriveKey(password)
  return await decrypt(key, encryptedObj)
}

async function encrypt (key, data) {
  const iv = crypto.getRandomValues(new Uint8Array(12))
  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    data
  )
  return {
    iv: Array.from(iv),
    ciphertext: Array.from(new Uint8Array(encryptedBuffer))
  }
}

async function decrypt (key, { iv, ciphertext }) {
  const ivArray = new Uint8Array(iv)
  const cipherArray = new Uint8Array(ciphertext)

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: ivArray },
    key,
    cipherArray
  )

  return new Uint8Array(decryptedBuffer)
}

async function deriveKey (password) {
  // convert password to bytes
  const passBytes = new TextEncoder().encode(password)

  // create a base key for PBKDF2
  const baseKey = await crypto.subtle.importKey(
    'raw',
    passBytes,
    { name: 'PBKDF2' },
    false,
    ['deriveBits', 'deriveKey']
  )

  // define a salt (must be consistent each time or store it)
  const salt = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8])

  // derive an AES-GCM 256-bit key
  return crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt,
      iterations: 100000,
      hash: 'SHA-256'
    },
    baseKey,
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt', 'decrypt']
  )
}
